/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { SetStateAction, useEffect, useState } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Button } from '@zeeve-platform/button-component';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Navigate } from 'react-router';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import Urls from '../../utils/urls';
import apiBackendInstance from '../../utils/axios';
import { prefixPath } from '../../utils/helpers';

interface protocolInfo {
  plan: {
    code: string;
    price: number;
  };
  addOnCodes: {
    code: string;
    price: number;
  }[];
}

interface Props {
  purchaseType: string;
}

const ProtocolPurchaseBody = ({ purchaseType }: Props) => {
  const [networkName, setNetworkname] = useState<string>('');
  const [redirect, setRedirect] = useState('');
  const [protocolData, setProtocolData] = useState({} as protocolInfo);
  const [managedHosting, setManagedHosting] = useState(true);
  const [cloudInfra, setCloudInfra] = useState('');
  const [nodeType, setNodeType] = useState('');
  const [nodeCost, setNodeCost] = useState<number>(0);
  const [nodeCount, setNodeCount] = useState<number>(1);
  const [infraType, setInfraType] = useState<number>(2);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [btnDisable, setBtnDisable] = useState<boolean>(false);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [redirectionUrl, setRedirectionUrl] = useState<string>('');
  const [purchaseResMsg, setPurchaseResMsg] = useState<string>('');
  const [totalCost, setTotalCost] = useState<number>(0);
  const [plancode, setPlancode] = useState<string>('');

  const getNetworkNameParams = () => {
    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });
    const { name, plan_code } = params;
    setNetworkname(name);
    setPlancode(plan_code);
  };
  if (redirect) {
    return <Navigate to={redirect} />;
  }
  const NodeTypes = [
    {
      name: 'Full',
      code: 'FULLNODE',
      disable: false,
      description: 'Full node type for syncing chain of Public Protocol.',
    },
    {
      name: 'Validator',
      code: 'VALIDATORNODE',
      disable: false,
      description: 'Validator node type for syncing the chain of a public protocol.',
    },
  ];

  const paths = [
    { name: 'Home', path: prefixPath('/dashboard') },
    { name: 'Marketplace', path: window.location.href.includes('dedicated-nodes') ? prefixPath('/marketplace') : prefixPath('/marketplace/staking-nodes') },
  ];
  const getCostByCode = (code: string) => {
    if (protocolData && protocolData.addOnCodes) {
      const priceChart = protocolData.addOnCodes;
      const isCodePresent = priceChart.find((o) => o.code === code);
      if (isCodePresent) {
        return isCodePresent?.price;
      }
      return 0;
    }
    return 0;
  };
  // Price API
  const getPlanDetails = async () => {
    setShowLoader(true);
    apiBackendInstance.get(Urls.getPlansData(plancode), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((res: any) => {
      if (res && res.data) {
        setProtocolData(res.data);
        setNodeCost(res.data.plan.price);
        setDataLoaded(true);
        setShowLoader(false);
        if (plancode === 'ETH') {
          setCloudInfra('ETHEREUMMANAGEDHOSTING');
        } else if (plancode === 'PLYGN') {
          setCloudInfra('POLYGONMANAGEDHOSTING');
        } else {
          setCloudInfra(`${plancode}MANAGEDHOSTING`);
        }
        if (window.location.pathname.includes('dedicated-node')) {
          setNodeType(`${plancode}${NodeTypes[0].code}`);
        } else {
          setNodeType(`${plancode}${NodeTypes[1].code}`);
        }
        calculateCost();
      }
    }).catch((err) => {
      setNodeCost(0);
      setShowLoader(false);
      console.error(err);
    });
  };

  useEffect(() => {
    getNetworkNameParams();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    hideMessage();
    calculateCost();
  }, [cloudInfra, nodeType, nodeCount, plancode]);

  const showMessage = (msg: string) => {
    const ptag = document.getElementById('etag');
    if (ptag) {
      ptag.style.display = 'block';
      ptag.innerHTML = msg;
    }
  };

  const hideMessage = () => {
    const ptag = document.getElementById('etag');
    if (ptag) {
      ptag.style.display = 'none';
    }
  };

  const calculateCost = () => {
    if (protocolData?.plan?.price === undefined || protocolData?.plan?.price === null) {
      return 0;
    }

    let cloudCost = 0;
    let nodeTypeCost = 0;
    if (cloudInfra) cloudCost = getCostByCode(cloudInfra);
    if (nodeType) nodeTypeCost = getCostByCode(nodeType);
    setNodeCost(protocolData?.plan?.price + cloudCost + nodeTypeCost || 0);
    setTotalCost(
      (protocolData?.plan?.price + cloudCost + nodeTypeCost) * nodeCount,
    );
    return null;
  };

  const setCloudCode = (val: string) => {
    setCloudInfra(val);
  };

  const validate = () => {
    if (
      dataLoaded
      && cloudInfra
      && cloudInfra.length > 0
      && nodeType
      && nodeType.length > 0
      && nodeCount > 0
      && nodeCount <= 100
    ) {
      hideMessage();
      return true;
    }
    if ((!cloudInfra || cloudInfra.length < 1) && infraType === 0) {
      showMessage('Please select cloud type.');
      return false;
    }
    if ((!cloudInfra || cloudInfra.length < 1) && infraType === 1) {
      showMessage('Please select cloud.');
      return false;
    }
    if (!cloudInfra) {
      showMessage('Please select cloud type.');
      return false;
    }
    if (!nodeType) {
      showMessage('select node type.');
      return false;
    }
    if (!nodeCount || nodeCount <= 0) {
      showMessage('Number of nodes cannot be less than 1.');
      return false;
    }
    if (nodeCount > 100) {
      showMessage('Number of nodes cannot be more than 100.');
      return false;
    }
    if (!protocolData || !protocolData.plan || !protocolData.plan.price) {
      showMessage('Please try after some time.');
      return false;
    }
    return false;
  };

  const buyPlan = async () => {
    if (!validate()) {
      return;
    }
    setBtnDisable(true);
    setShowLoader(true);
    const codesArr = [];
    if (cloudInfra !== 'NOCODE') {
      codesArr.push(cloudInfra);
    }
    if (nodeType !== 'NOCODE') {
      codesArr.push(nodeType);
    }
    const data = {
      quantity: nodeCount,
      addOnCodes: codesArr,
      planCode: protocolData.plan.code,
    };
    setBtnDisable(false);
    setShowLoader(false);
    apiBackendInstance.post(Urls.createSubscription(), {
      ...data,
    }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((res: any) => {
      if (res) {
        setModalShow(true);
        setPurchaseResMsg(res.data.message);
        setRedirectionUrl(res.data.redirectionUrl);
      }
    }).catch((err) => {
      setPurchaseResMsg('Error request failed');
      setModalShow(false);
      console.error(err);
    });
  };
  const continueNext = () => {
    window.open(redirectionUrl, '_self');
  };

  const nodeCountHandler = (value: string) => {
    if ((parseInt(value, 10) > 0) && (parseInt(value, 10) < 101)) {
      setNodeCount(parseInt(value, 10));
    } else if ((parseInt(value, 10) < 1)) {
      showMessage('Number of nodes cannot be less than 1.');
    } else if ((parseInt(value, 10) > 100)) {
      showMessage('Number of nodes cannot be more than 100.');
    }
  };

  const setImage = (val: string) => {
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      // val = val.split(' ')[1];
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.replace(/\s/g, '');
    }
    switch (val.toLowerCase()) {
      case 'bitcoin': return '../../images/protocols/logos/bitcoin_logo.svg';
      case 'kusama': return '../../images/protocols/logos/kusama_logo.svg';
      case 'acala': return '../../images/protocols/logos/acala_logo.svg';
      case 'moonbeam': return '../../images/protocols/logos/Moonbeam_logo.svg';
      case 'tezos': return '../../images/protocols/logos/tezos_logo.svg';
      case 'arbitrum': return '../../images/protocols/logos/arbitrum_logo.svg';
      case 'aurora': return '../../images/protocols/logos/aurora_logo.svg';
      case 'base': return '../../images/protocols/logos/base_logo.svg';
      case 'harmony': return '../../images/protocols/logos/harmony_logo.svg';
      case 'klaytn': return '../../images/protocols/logos/klaytn_logo.svg';
      case 'near': return '../../images/protocols/logos/near_logo.svg';
      case 'optimism': return '../../images/protocols/logos/optimism_logo.svg';
      case 'algorand': return '../../images/protocols/logos/algorand_logo.svg';
      case 'aptos': return '../../images/protocols/logos/Aptos_logo.svg';
      case 'arbitrumnova': return '../../images/protocols/logos/arbitrum_nova_logo.svg';
      case 'cardano': return '../../images/protocols/logos/cardano_logo.svg';
      case 'celo': return '../../images/protocols/logos/celo_logo.svg';
      case 'cosmos': return '../../images/protocols/logos/cosmos_logo.svg';
      case 'cronos': return '../../images/protocols/logos/cronos_logo.svg';
      case 'flow': return '../../images/protocols/logos/flow_logo.svg';
      case 'fuse': return '../../images/protocols/logos/fuse_logo.svg';
      case 'gnosischain': return '../../images/protocols/logos/gnosischain_logo.svg';
      case 'hedera': return '../../images/protocols/logos/hedera_logo.svg';
      case 'lisk': return '../../images/protocols/logos/lisk_logo.svg';
      case 'nervos': return '../../images/protocols/logos/nervos_logo.svg';
      case 'persistence': return '../../images/protocols/logos/persistence_logo.svg';
      case 'solana': return '../../images/protocols/logos/solana_logo.svg';
      case 'stacks': return '../../images/protocols/logos/stacks_logo.svg';
      case 'ton': return '../../images/protocols/logos/ton_logo.svg';
      case 'telos': return '../../images/protocols/logos/telos_logo.svg';
      case 'xdc': return '../../images/protocols/logos/xdc_logo.svg';
      case 'tron': return '../../images/protocols/logos/tron_logo.svg';
      case 'ethereum': return '../../images/protocols/logos/ethereum_logo.svg';
      case 'binance': return '../../images/protocols/logos/binance_logo.svg';
      case 'okc': return '../../images/protocols/logos/okc_logo.svg';
      case 'polygon': return '../../images/protocols/logos/Polygonpos_logo.svg';
      case 'fantom': return '../../images/protocols/logos/Fantom_logo.svg';
      case 'zkevm': return '../../images/protocols/logos/zkevm_logo.svg';
      case 'starknet': return '../../images/protocols/logos/starknet_logo.png';
      case 'zksyncera': return '../../images/protocols/logos/zksyncera_logo.svg';
      case 'provenanceblockchain': return '../../images/protocols/logos/provenance_blockchain_logo.svg';
      case 'opstack': return '../../images/protocols/logos/opstack_logo.svg';
      case 'arbitrumorbit': return '../../images/protocols/logos/arbitrum_orbit_logo.svg';
      case 'subsquid': return '../../images/protocols/logos/subsquid-logo-dark.svg';

      default: return '';
    }
  };
  useEffect(() => {
    getNetworkNameParams();
    window.scrollTo(0, 10);
  }, [redirect]);
  useEffect(() => {
    hideMessage();

    calculateCost();
  }, [cloudInfra, nodeType, nodeCount, plancode]);

  useEffect(() => {
    if (plancode) {
      getPlanDetails();
    }
  }, [plancode]);
  return (
    <section className="px-5 col-12 workspace">
      <div className="mt-5 col-11 mx-auto">
        <div className="row">
          <div className="col-xl-8 col-lg-8 col-sm-12 mx-auto">
            <div className="col-4">
              <img src={setImage(networkName)} height={32} alt="logo" />
            </div>
            <div className="mt-2">
              <Breadcrumb
                prefixLink={paths}
                activeLink={
                  purchaseType === 'dedicatedNode'
                    ? 'Full Node Subscription'
                    : 'Validator Node Subscription'
                }
                textSize={13}
              />
            </div>
            <div className="mt-5">
              <h5>
                <b>Select Subscription Options</b>
              </h5>
              <label htmlFor="z21" className="mt-4" style={{ fontWeight: 700 }}>
                Select Cloud Type
              </label>
              <div className="row mt-3 radioleft">
                <div className="form-check col-xl-5 col-lg-5 col-lg-6 col-sm-12">
                  <Inputbox
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault15"
                    id="flexRadioDefault15"
                    value={`${plancode}MANAGEDHOSTING`}
                    checked
                    onChange={(e: { target: { value: string } }) => {
                      setManagedHosting(true);
                      setInfraType(2);
                      setCloudCode(e.target.value);
                    }}
                  />
                  <label
                    className="form-check-label mx-2"
                    htmlFor="flexRadioDefault15"
                  >
                    Zeeve Managed Cloud
                    <i
                      title="Choose Zeeve's managed hosting for your node infrastructure."
                      className="mx-2 fa fa-info-circle"
                    />
                  </label>
                </div>
              </div>
            </div>
            {/* && <Loading /> */}
            <div className="mt-4 col-12">
              <label
                htmlFor={`custom-radio-syncmode-${0}`}
                style={{ fontWeight: 700 }}
              >
                Select Node Type
              </label>
              <div className="row mt-3 mx-2">
                {purchaseType === 'dedicatedNode' ? (
                  <div className="form-check col-xl-3 col-lg-3 col-sm-3 col-md-3">
                    <Inputbox
                      name="syncMode"
                      type="radio"
                      className="form-check-input"
                      id={`custom-radio-syncmode-${0}`}
                      disabled={NodeTypes[0].disable}
                      value={`${plancode}${NodeTypes[0].code}`}
                      checked="checked"
                      onChange={(e: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        setNodeType(e.target.value);
                      }}
                    />
                    <label
                      className="form-check-label mx-2"
                      htmlFor={`custom-radio-syncmode-${0}`}
                    >
                      {NodeTypes[0].name}
                      <i
                        title={NodeTypes[0].description}
                        className="mx-2 fa fa-info-circle"
                      />
                    </label>
                  </div>
                ) : (
                  <div className="form-check col-xl-6 col-lg-6 col-sm-6 col-md-6">
                    <Inputbox
                      name="syncMode"
                      type="radio"
                      className="form-check-input"
                      id={`custom-radio-syncmode-${1}`}
                      disabled={NodeTypes[1].disable}
                      value={`${plancode}${NodeTypes[1].code}`}
                      checked="checked"
                      onChange={(e: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        setNodeType(e.target.value);
                      }}
                    />
                    <label
                      className="form-check-label mx-2"
                      htmlFor={`custom-radio-syncmode-${1}`}
                    >
                      {NodeTypes[1].name}
                      <i
                        title={NodeTypes[1].description}
                        className="mx-2 fa fa-info-circle"
                      />
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="alert-danger mt-4 rounded text-center">
              <p
                className="text-danger  py-2"
                style={{ display: 'none' }}
                id="etag"
              >
                error
              </p>
            </div>
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-12 col-sm-12"
            style={{ marginTop: '15%' }}
          >
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="monthly-cost"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Per Node Monthly Cost (USD)
              </label>
              <Inputbox
                type="text"
                className="form-control"
                id="monthly-cost"
                aria-describedby="emailHelp"
                value={`$ ${nodeCost}`}
                disabled
              />
            </div>
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="num-nodes"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Enter Number of Nodes
              </label>
              <div className="input-group">
                <Inputbox
                  type="number"
                  className="form-control rounded-start"
                  style={{ borderRadius: '8px 0px 0px 8px !important' }}
                  id="num-nodes"
                  value={nodeCount}
                  min={1}
                  onChange={(e: { target: { value: string } }) => nodeCountHandler(e.target.value)}
                />
                <span
                  className="input-group-text cursor"
                  style={{ borderRadius: '0px 8px 8px 0px !important' }}
                >
                  Nodes
                </span>
              </div>
            </div>
            <div className="mb-4 subcriptioninput">
              <label
                htmlFor="total-cost"
                className="form-label mb-2"
                style={{ fontWeight: 700 }}
              >
                Total Monthly Cost (USD)
              </label>
              <input
                type="text"
                className="form-control"
                id="total-cost"
                aria-describedby="emailHelp"
                value={`$ ${totalCost}`}
                disabled
              />
            </div>
            <div className="row mt-3 mb-5">
              <div className="mx-1 col-5">
                <Button
                  type="button"
                  disabled={btnDisable}
                  className="btn btn-success rounded"
                  onClick={() => {
                    buyPlan();
                  }}
                >
                  Subscribe
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={`Purchasing ${networkName}`}
        visibleFooter
        visibleFooterCloseButton
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={redirectionUrl !== ''}
        confirmBtnText="Continue"
        onConfirm={continueNext}
        confirmBtnClassName=""
      >
        <p className="status text-center pt-3">{purchaseResMsg}</p>
      </Modal>
    </section>
  );
};

export default ProtocolPurchaseBody;